import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar/Sidebar";
import AdminList from "../../../components/AdminList/AdminList";
import Modal from "../../../components/Modal/Modal";
import { getDepartments, deleteDepartment, createDepartment, updateDepartment } from "../../../utils/api";

const columns = [
  { key: "name", label: "Name" },
  { key: "description", label: "Description" },
  { 
    key: "createdOn", 
    label: "Created On",
    render: (value) => value ? new Date(value).toLocaleDateString() : "-"
  },
];

const filters = [
  {
    key: "name",
    label: "Search by Name",
    type: "search"
  },
];

export default function Departments() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: ""
  });
  const [loading, setLoading] = useState(false);

  const handleAdd = () => {
    setFormData({ name: "", description: "" });
    setIsEditMode(false);
    setSelectedDepartment(null);
    setModalOpen(true);
  };

  const handleEdit = (department) => {
    setSelectedDepartment(department);
    setFormData({
      name: department.name || "",
      description: department.description || ""
    });
    setIsEditMode(true);
    setModalOpen(true);
  };

  const handleView = (department) => {
    handleEdit(department);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isEditMode && selectedDepartment) {
        await updateDepartment(selectedDepartment._id, formData);
        alert("Department updated successfully!");
      } else {
        await createDepartment(formData);
        alert("Department created successfully!");
      }
      setModalOpen(false);
    } catch (error) {
      alert(error.message || "Failed to save department");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <AdminList
          title="Departments"
          fetchData={getDepartments}
          deleteData={deleteDepartment}
          columns={columns}
          onEdit={handleEdit}
          onAdd={handleAdd}
          onView={handleView}
          filters={filters}
          searchPlaceholder="Search departments..."
        />
      </main>

      {/* Create/Edit Department Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        title={isEditMode ? "Edit Department" : "Add New Department"}
        size="medium"
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Department Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleFormChange}
              required
              placeholder="Enter department name"
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleFormChange}
              rows="4"
              placeholder="Enter department description"
            />
          </div>
          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalOpen(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Saving..." : (isEditMode ? "Update Department" : "Create Department")}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
